import { render, staticRenderFns } from "./FavouriteIcon.vue?vue&type=template&id=a36357e8&"
import script from "./FavouriteIcon.vue?vue&type=script&lang=js&"
export * from "./FavouriteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports